<div class="indicator-content">
  <div class="indicator-header">
    <span class="indicator-title">Valor de Movimentação <b>(R$)</b></span>
    <div fxLayoutAlign="end center">
      <indicator-filter (filterDataEvent)="onFilterData($event)"></indicator-filter>
    </div>
  </div>
  <div *ngIf="isLoading" class="loader-container">
    <indicator-loader></indicator-loader>
  </div>
  <div *ngIf="!isLoading" class="indicator-content-container">
    <canvas
      baseChart
      [data]="lineChartData"
      [options]="lineChartOptions"
      [type]="'line'"
      ></canvas>
  </div>
</div>
